import React, { Component } from 'react';

class LanguageSwitcher extends Component {

  render() {
    return (
      <div className="languageswitcher">
        <ul>
          <li onClick={() => this.props.setLocale('de')} className={this.props.locale === 'de' ? 'active' : ''} data-lang='de'>Deutsch</li>
          <li onClick={() => this.props.setLocale('fr')} className={this.props.locale === 'fr' ? 'active' : ''} data-lang='fr'>Français</li>
          <li onClick={() => this.props.setLocale('it')} className={this.props.locale === 'it' ? 'active' : ''} data-lang='it'>Italiano</li>
        </ul>
      </div>
    )
  }
};

export default LanguageSwitcher;



// WEBPACK FOOTER //
// ./src/LanguageSwitcher.js